"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kind = void 0;
var Kind;
(function (Kind) {
    /*
     * Elementary
     */
    Kind.isElementary = (kind) => "type" in kind;
    Kind.isUserDefinedValueType = (kind) => Kind.isElementary(kind) && "identifier" in kind;
    Kind.isArray = (kind) => "itemKind" in kind;
    let Array;
    (function (Array) {
        Array.isStatic = (kind) => Kind.isArray(kind) && typeof kind.length === "number";
        Array.isDynamic = (kind) => Kind.isArray(kind) && typeof kind.length !== "number";
    })(Array = Kind.Array || (Kind.Array = {}));
    Kind.isStruct = (kind) => "members" in kind;
    let Struct;
    (function (Struct) {
        ;
    })(Struct = Kind.Struct || (Kind.Struct = {}));
    Kind.isInterface = (kind) => 
    // only has key identifier
    Object.keys(kind).filter(key => key !== "identifier").length === 0;
})(Kind = exports.Kind || (exports.Kind = {}));
//# sourceMappingURL=kind.js.map